(function () {
  'use strict';

  var CONFIG = {
    maxLength: 12,
    allowedPattern: /^[a-zA-Z0-9\s!@#$%^&*()_\-.,'"]*$/
  };

  var drawer = null;
  var moneyFormat = '${{amount}}';
  var productData = null;
  var currentVariantId = null;
  var editContext = null;
  var quantity = 1;
  var isOpen = false;
  var openOptions = {};
  var drawerStep = 'main';
  var upsellQueue = [];
  var upsellQueueIndex = 0;
  var postAddMeta = {};
  var isStepAnimating = false;
  var inline3dApi = null;

  var els = {};

  function is360PreviewEnabled() {
    return window.RABITAT_360_PREVIEW_ENABLED === true;
  }

  function formatMoney(cents) {
    if (typeof Shopify !== 'undefined' && typeof Shopify.formatMoney === 'function') {
      return Shopify.formatMoney(cents, moneyFormat);
    }
    return (cents / 100).toFixed(2);
  }

  function setFormattedMoney(element, formatted, cents) {
    if (!element) return;
    if (formatted) {
      element.innerHTML = formatted;
      return;
    }
    element.textContent = formatMoney(cents);
  }

  function isBrowseQuickAddContext() {
    var templateName = document.body && document.body.dataset.templateName;
    var templateSuffix = document.body && document.body.dataset.templateSuffix;
    if (templateName === 'collection' && templateSuffix === 'diwali') return true;
    return templateName !== 'product' && templateName !== 'collection';
  }

  function shouldShowVariantPicker() {
    if (!isBrowseQuickAddContext()) return false;
    if (openOptions.hideVariants) return false;
    if (editContext) return false;
    if (!productData || !productData.variants) return false;
    return productData.variants.length > 1;
  }

  function shouldShowViewFullDetails(isUpsell) {
    if (isUpsell) return false;
    if (!isBrowseQuickAddContext()) return false;
    if (openOptions.hideViewProduct) return false;
    return true;
  }

  function updateViewProductLink(isUpsell) {
    if (!els.viewProduct) return;

    if (shouldShowViewFullDetails(isUpsell)) {
      els.viewProduct.hidden = false;
      els.viewProduct.removeAttribute('hidden');
    } else {
      els.viewProduct.hidden = true;
      els.viewProduct.setAttribute('hidden', '');
    }
  }

  function getDrawer() {
    if (!drawer) {
      drawer = document.getElementById('RabitatQuickAddDrawer');
      if (drawer) {
        moneyFormat = drawer.getAttribute('data-money-format') || moneyFormat;
        cacheElements();
        bindDrawerEvents();
      }
    }
    return drawer;
  }

  function cacheElements() {
    els.overlay = drawer.querySelector('.rabitat-quick-add__overlay');
    els.panel = drawer.querySelector('.rabitat-quick-add__panel');
    els.title = drawer.querySelector('[data-quick-add-title]');
    els.content = drawer.querySelector('[data-quick-add-content]');
    els.footer = drawer.querySelector('.rabitat-quick-add__footer');
    els.variantName = drawer.querySelector('[data-quick-add-variant-name]');
    els.image = drawer.querySelector('[data-quick-add-image]');
    els.overlays = drawer.querySelector('[data-quick-add-overlays]');
    els.variantsWrap = drawer.querySelector('[data-quick-add-variants]');
    els.variantList = drawer.querySelector('[data-quick-add-variant-list]');
    els.price = drawer.querySelector('[data-quick-add-price]');
    els.compare = drawer.querySelector('[data-quick-add-compare]');
    els.discount = drawer.querySelector('[data-quick-add-discount]');
    els.personalizeWrap = drawer.querySelector('[data-quick-add-personalize]');
    els.personalizeHeading = drawer.querySelector('[data-quick-add-personalize-heading]');
    els.slots = drawer.querySelector('[data-quick-add-slots]');
    els.error = drawer.querySelector('[data-quick-add-error]');
    els.qtyValue = drawer.querySelector('[data-quick-add-qty-value]');
    els.qtyMinus = drawer.querySelector('[data-quick-add-qty-minus]');
    els.qtyPlus = drawer.querySelector('[data-quick-add-qty-plus]');
    els.submit = drawer.querySelector('[data-quick-add-submit]');
    els.viewProduct = drawer.querySelector('[data-quick-add-view-product]');
    els.skip = drawer.querySelector('[data-quick-add-skip]');
    els.stepHeader = drawer.querySelector('[data-quick-add-step-header]');
    els.stepHeading = drawer.querySelector('[data-quick-add-step-heading]');
    els.benefitsWrap = drawer.querySelector('[data-quick-add-benefits]');
    els.benefitsList = drawer.querySelector('[data-quick-add-benefits-list]');
    els.preview360 = drawer.querySelector('[data-quick-add-preview-360]');
    els.pricesWrap = drawer.querySelector('.rabitat-quick-add__prices');
    els.taxNote = drawer.querySelector('.rabitat-quick-add__tax-note');
    initInline3dMedia();
  }

  function applyQuickAddPriceDisplay(variant) {
    var isPpcod =
      productData &&
      productData.ppcod_pdp === true &&
      productData.ppcod_price_label;

    if (els.pricesWrap) {
      els.pricesWrap.classList.toggle('rabitat-quick-add__prices--ppcod', !!isPpcod);
    }

    if (isPpcod) {
      if (els.price) {
        els.price.textContent = productData.ppcod_price_label;
      }
      if (els.compare) {
        els.compare.innerHTML = '';
        els.compare.hidden = true;
      }
      if (els.discount) {
        els.discount.textContent = '';
        els.discount.hidden = true;
      }
      if (els.taxNote) {
        els.taxNote.hidden = true;
        els.taxNote.setAttribute('hidden', '');
      }
      return;
    }

    if (els.taxNote) {
      els.taxNote.hidden = false;
      els.taxNote.removeAttribute('hidden');
    }

    if (els.price) {
      setFormattedMoney(els.price, variant.price_formatted, variant.price);
    }

    if (els.compare) {
      if (variant.compare_at_price > variant.price) {
        setFormattedMoney(els.compare, variant.compare_formatted, variant.compare_at_price);
        els.compare.hidden = false;
        els.compare.removeAttribute('hidden');
      } else {
        els.compare.innerHTML = '';
        els.compare.hidden = true;
        els.compare.setAttribute('hidden', '');
      }
    }

    if (els.discount) {
      if (variant.compare_at_price > variant.price) {
        var discountPercent = Math.round((1 - variant.price / variant.compare_at_price) * 100);
        els.discount.textContent = discountPercent + '% Off';
        els.discount.hidden = false;
        els.discount.removeAttribute('hidden');
      } else {
        els.discount.textContent = '';
        els.discount.hidden = true;
        els.discount.setAttribute('hidden', '');
      }
    }
  }

  function applyHotspotLabelStyle(element, textStyle) {
    if (!element || !textStyle) return;
    element.style.fontSize = textStyle.fontSize || '14px';
    element.style.color = textStyle.color || '#808080';
    element.style.fontWeight = textStyle.fontWeight || '500';
    element.style.letterSpacing = textStyle.letterSpacing || '-0.5px';
    element.style.writingMode = textStyle.writingMode || 'horizontal-tb';
    element.style.textTransform = 'capitalize';
    element.style.whiteSpace = 'nowrap';
  }

  function screenPointFromTextStyle(textStyle, width, height) {
    var leftRaw = textStyle && textStyle.left != null ? String(textStyle.left) : '50%';
    var bottomRaw = textStyle && textStyle.bottom != null ? String(textStyle.bottom) : '15%';
    var x = width / 2;
    var y = height * 0.85;

    if (leftRaw.indexOf('%') !== -1) {
      x = (width * parseFloat(leftRaw)) / 100;
    } else if (!isNaN(parseFloat(leftRaw))) {
      x = parseFloat(leftRaw);
    }

    if (bottomRaw.indexOf('%') !== -1) {
      y = height * (1 - parseFloat(bottomRaw) / 100);
    } else if (!isNaN(parseFloat(bottomRaw))) {
      y = height - parseFloat(bottomRaw);
    }

    return { x: x, y: y };
  }

  function getHotspotPoints() {
    if (!drawer) return [];

    var root = drawer.querySelector('[data-inline-3d-root]');
    if (!root || !els.overlays) return [];

    var rootRect = root.getBoundingClientRect();
    var layer2d = root.querySelector('[data-inline-3d-2d]');
    var useLiveRects = !!(layer2d && !layer2d.hidden);
    var pData = currentVariantId ? getPersonalizationData(currentVariantId) : null;
    var slots = pData && pData.slots && pData.slots.length ? pData.slots : [];
    var points = [];

    els.overlays.querySelectorAll('.rabitat-quick-add__text-overlay').forEach(function (overlay, index) {
      var text = overlay.textContent ? overlay.textContent.trim() : '';
      if (!text) return;

      var slot = slots[index] || {};
      var textStyle = slot.textStyle || (pData && pData.textStyle) || {};
      var x;
      var y;

      if (useLiveRects) {
        var rect = overlay.getBoundingClientRect();
        x = rect.left + rect.width / 2 - rootRect.left;
        y = rect.top + rect.height / 2 - rootRect.top;
      } else {
        var coords = screenPointFromTextStyle(textStyle, rootRect.width, rootRect.height);
        x = coords.x;
        y = coords.y;
      }

      points.push({
        slot: index + 1,
        text: text,
        textStyle: textStyle,
        x: x,
        y: y
      });
    });

    return points;
  }

  function initInline3dMedia() {
    if (!is360PreviewEnabled()) return;
    if (!window.RabitatInline3d || !drawer) return;

    var root = drawer.querySelector('[data-inline-3d-root]');
    if (!root) return;

    inline3dApi = window.RabitatInline3d.init(root, {
      getGlbUrl: function () {
        return currentVariantId ? getGlbUrl(currentVariantId) : null;
      },
      getPosterUrl: function () {
        return els.image && els.image.src ? els.image.src : null;
      },
      canOpen: function () {
        return !!(currentVariantId && getGlbUrl(currentVariantId));
      },
      getHotspotPoints: function () {
        return [];
      },
      onError: function () {
        if (els.error) {
          els.error.textContent = 'Unable to load 3D preview. Please try again.';
          els.error.hidden = false;
        }
      }
    });
  }

  function closeInline3d() {
    if (!is360PreviewEnabled()) return;
    if (inline3dApi) inline3dApi.close();
  }

  function getGlbUrl(variantId) {
    var id = String(variantId);
    var variant = getVariantById(variantId);
    var pData = getPersonalizationData(variantId);
    var map = getVariantGlbMap();
    var fromSwatch = getGlbUrlFromSwatch(id);

    return normalizeGlbUrl(
      (pData && pData.glbUrl) ||
      (variant && variant.glbUrl) ||
      map[id] ||
      fromSwatch
    );
  }

  function normalizeGlbUrl(url) {
    if (url == null || url === 'null' || url === 'undefined') return null;
    url = String(url).trim();
    if (!url.length) return null;
    if (/\.usdz(\?|#|$)/i.test(url)) {
      return url.replace(/\.usdz(?=[?#]|$)/i, '.glb');
    }
    return url;
  }

  function getVariantGlbMap() {
    if (window.__rabitatVariantGlbMap) return window.__rabitatVariantGlbMap;

    window.__rabitatVariantGlbMap = {};
    var el = document.querySelector('[data-variant-glb-map]');
    if (!el) return window.__rabitatVariantGlbMap;

    try {
      window.__rabitatVariantGlbMap = JSON.parse(el.textContent.trim()) || {};
    } catch (error) {
      window.__rabitatVariantGlbMap = {};
    }

    return window.__rabitatVariantGlbMap;
  }

  function getGlbUrlFromSwatch(variantId) {
    var swatch = document.querySelector('[data-product-swatch][value="' + variantId + '"]');
    if (!swatch) return null;
    return swatch.getAttribute('data-glb-url');
  }

  function hasPersonalizationText() {
    return getPersonalizationTexts().some(function (text) {
      return text.length > 0;
    });
  }

  function updatePreview360Button() {
    if (!els.preview360) return;

    if (!is360PreviewEnabled()) {
      els.preview360.hidden = true;
      els.preview360.setAttribute('hidden', '');
      els.preview360.disabled = true;
      els.preview360.setAttribute('aria-disabled', 'true');
      els.preview360.title = '';
      return;
    }

    var glbUrl = currentVariantId ? getGlbUrl(currentVariantId) : null;

    if (!glbUrl) {
      els.preview360.hidden = true;
      els.preview360.setAttribute('hidden', '');
      els.preview360.disabled = true;
      els.preview360.setAttribute('aria-disabled', 'true');
      els.preview360.title = '';
      return;
    }

    els.preview360.hidden = false;
    els.preview360.removeAttribute('hidden');
    els.preview360.disabled = false;
    els.preview360.setAttribute('aria-disabled', 'false');
    els.preview360.title = 'View bottle in 360°';
  }

  function bindDrawerEvents() {
    drawer.querySelectorAll('[data-quick-add-close]').forEach(function (btn) {
      btn.addEventListener('click', close);
    });

    if (els.qtyMinus) {
      els.qtyMinus.addEventListener('click', function () {
        quantity = Math.max(1, quantity - 1);
        els.qtyValue.textContent = String(quantity);
      });
    }

    if (els.qtyPlus) {
      els.qtyPlus.addEventListener('click', function () {
        quantity += 1;
        els.qtyValue.textContent = String(quantity);
      });
    }

    if (els.submit) {
      els.submit.addEventListener('click', handleAddToCart);
    }

    if (els.skip) {
      els.skip.addEventListener('click', function () {
        advanceUpsellStep(true);
      });
    }

    document.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape') return;
      if (inline3dApi && inline3dApi.isOpen()) {
        event.stopPropagation();
        closeInline3d();
        return;
      }
      if (isOpen) {
        close();
      }
    });
  }

  function getVariantById(id) {
    if (!productData || !productData.variants) return null;
    for (var i = 0; i < productData.variants.length; i++) {
      if (String(productData.variants[i].id) === String(id)) {
        return productData.variants[i];
      }
    }
    return null;
  }

  function getPersonalizationData(variantId) {
    if (!productData || !productData.personalization) return null;
    return productData.personalization[String(variantId)] || productData.personalization[variantId] || null;
  }

  function applyTextStyle(element, textStyle) {
    if (!element || !textStyle) return;
    element.style.position = 'absolute';
    element.style.bottom = textStyle.bottom || '15%';
    element.style.top = textStyle.top || 'auto';
    element.style.left = textStyle.left || '50%';
    element.style.right = textStyle.right || 'auto';
    element.style.transform = textStyle.transform || 'translateX(-50%)';
    element.style.fontSize = textStyle.fontSize || '14px';
    element.style.color = textStyle.color || '#808080';
    element.style.fontWeight = textStyle.fontWeight || '500';
    element.style.letterSpacing = textStyle.letterSpacing || '-0.5px';
    element.style.writingMode = textStyle.writingMode || 'horizontal-tb';
  }

  function buildPersonalizationSlots(pData) {
    if (!els.slots || !pData) return;
    els.slots.innerHTML = '';
    els.overlays.innerHTML = '';

    var slots = pData.slots && pData.slots.length ? pData.slots : [{
      label: 'Product 1',
      maxCharacters: pData.maxCharacters || CONFIG.maxLength,
      textStyle: pData.textStyle || {}
    }];

    slots.forEach(function (slot, index) {
      var slotNum = index + 1;
      var overlay = document.createElement('div');
      overlay.className = 'rabitat-quick-add__text-overlay';
      overlay.setAttribute('data-slot', String(slotNum));
      applyTextStyle(overlay, slot.textStyle);
      els.overlays.appendChild(overlay);

      var wrap = document.createElement('div');
      wrap.className = 'rabitat-quick-add__slot';

      var label = document.createElement('label');
      label.className = 'rabitat-quick-add__slot-label';
      label.setAttribute('for', 'quickAddInput' + slotNum);
      label.textContent = slot.label || 'Product ' + slotNum;

      var inputWrap = document.createElement('div');
      inputWrap.className = 'rabitat-quick-add__input-wrap';

      var input = document.createElement('input');
      input.type = 'text';
      input.id = 'quickAddInput' + slotNum;
      input.className = 'rabitat-quick-add__input';
      input.placeholder = 'Your engraving name (optional)';
      input.autocomplete = 'off';
      input.style.fontSize = '16px';
      input.style.webkitTextSizeAdjust = '100%';
      input.maxLength = slot.maxCharacters || CONFIG.maxLength;
      input.setAttribute('data-slot', String(slotNum));

      var counter = document.createElement('span');
      counter.className = 'rabitat-quick-add__char-count';
      counter.innerHTML = '0/' + (slot.maxCharacters || CONFIG.maxLength);

      input.addEventListener('input', function () {
        overlay.textContent = input.value;
        counter.textContent = input.value.length + '/' + input.maxLength;
        if (els.error) {
          els.error.hidden = true;
          els.error.textContent = '';
        }
        updatePreview360Button();
      });

      inputWrap.appendChild(input);
      inputWrap.appendChild(counter);
      wrap.appendChild(label);
      wrap.appendChild(inputWrap);
      els.slots.appendChild(wrap);
    });
  }

  function renderVariant(variantId) {
    var variant = getVariantById(variantId);
    if (!variant) return;

    closeInline3d();
    currentVariantId = variant.id;
    quantity = 1;
    if (els.qtyValue) els.qtyValue.textContent = '1';

    var pData = getPersonalizationData(variant.id);
    var displayImage = variant.image;

    if (pData && pData.image) {
      displayImage = pData.image;
    }

    if (els.image) {
      els.image.src = displayImage || '';
      els.image.alt = productData.title || 'Rabitat';
      els.image.setAttribute('data-alt', productData.title || 'Rabitat');
    }

    applyQuickAddPriceDisplay(variant);

    if (els.variantName) {
      els.variantName.textContent = variant.name || '';
    }

    if (els.variantList) {
      els.variantList.querySelectorAll('[data-variant-id]').forEach(function (btn) {
        var selected = String(btn.getAttribute('data-variant-id')) === String(variant.id);
        btn.classList.toggle('is-selected', selected);
        btn.setAttribute('aria-pressed', selected ? 'true' : 'false');
      });
    }

    var feeNote = drawer.querySelector('[data-personalization-fee-note]');

    if (productData.personalizable && pData) {
      if (els.personalizeWrap) els.personalizeWrap.hidden = false;
      var heading = productData.id === 9081101943007 ? 'Customize' : 'Personalize';
      if (els.personalizeHeading) els.personalizeHeading.textContent = heading;
      buildPersonalizationSlots(pData);
      if (window.RabitatPersonalizationFee && typeof window.RabitatPersonalizationFee.syncProductId === 'function') {
        window.RabitatPersonalizationFee.syncProductId(feeNote, productData.id);
      } else if (feeNote && productData.id) {
        feeNote.setAttribute('data-product-id', String(productData.id));
      }
      if (window.RabitatPersonalizationFee && typeof window.RabitatPersonalizationFee.updateAll === 'function') {
        window.RabitatPersonalizationFee.updateAll(drawer);
      }
    } else {
      if (els.personalizeWrap) els.personalizeWrap.hidden = true;
      if (els.slots) els.slots.innerHTML = '';
      if (els.overlays) els.overlays.innerHTML = '';
      if (window.RabitatPersonalizationFee && typeof window.RabitatPersonalizationFee.syncProductId === 'function') {
        window.RabitatPersonalizationFee.syncProductId(feeNote, null);
      } else if (feeNote) {
        feeNote.removeAttribute('data-product-id');
      }
    }

    updatePreview360Button();

    if (els.viewProduct && variant.url) {
      els.viewProduct.href = variant.url;
    }

    if (els.submit) {
      els.submit.disabled = !variant.available;
      if (editContext) {
        els.submit.textContent = 'Save personalization';
      } else {
        els.submit.textContent = variant.available ? (productData.cart_label || 'Add To Cart') : (productData.sold_out_label || 'Sold out');
      }
    }

    updateSubmitLabel();
  }

  function renderVariantButtons() {
    if (!els.variantList || !productData || !productData.variants) return;

    els.variantList.innerHTML = '';

    if (!shouldShowVariantPicker()) {
      if (els.variantsWrap) {
        els.variantsWrap.hidden = true;
        els.variantsWrap.setAttribute('hidden', '');
      }
      return;
    }

    productData.variants.forEach(function (variant) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'rabitat-quick-add__variant-btn';
      btn.setAttribute('data-variant-id', String(variant.id));
      btn.setAttribute(
        'aria-label',
        variant.available ? variant.name || 'Variant' : (variant.name || 'Variant') + ' (Sold Out)'
      );
      btn.setAttribute('aria-pressed', String(variant.id) === String(currentVariantId) ? 'true' : 'false');
      if (!variant.available) btn.classList.add('is-sold-out');

      if (variant.image) {
        var img = document.createElement('img');
        img.className = 'rabitat-quick-add__variant-thumb';
        img.src = variant.image;
        img.alt = variant.name || '';
        img.loading = 'lazy';
        img.width = 48;
        img.height = 48;
        btn.appendChild(img);
      } else {
        btn.textContent = variant.name || '';
      }

      btn.addEventListener('click', function () {
        renderVariant(variant.id);
      });

      els.variantList.appendChild(btn);
    });

    if (els.variantsWrap) {
      els.variantsWrap.hidden = false;
      els.variantsWrap.removeAttribute('hidden');
    }

    if (currentVariantId && els.variantList) {
      els.variantList.querySelectorAll('[data-variant-id]').forEach(function (btn) {
        var selected = String(btn.getAttribute('data-variant-id')) === String(currentVariantId);
        btn.classList.toggle('is-selected', selected);
      });
    }
  }

  function getFirstAvailableVariantId(data) {
    if (!data || !data.variants) return null;
    for (var i = 0; i < data.variants.length; i++) {
      if (data.variants[i].available) return data.variants[i].id;
    }
    return data.variants[0] ? data.variants[0].id : null;
  }

  function renderBenefits() {
    if (!els.benefitsWrap || !els.benefitsList) return;

    var lines = (postAddMeta.upsell_benefits || '')
      .split('\n')
      .map(function (line) {
        return line.trim();
      })
      .filter(Boolean);

    els.benefitsList.innerHTML = '';

    if (!lines.length) {
      els.benefitsWrap.hidden = true;
      els.benefitsWrap.setAttribute('hidden', '');
      return;
    }

    lines.forEach(function (line) {
      var item = document.createElement('li');
      item.textContent = line;
      els.benefitsList.appendChild(item);
    });

    els.benefitsWrap.hidden = false;
    els.benefitsWrap.removeAttribute('hidden');
  }

  function setDrawerStepUI(isUpsell) {
    if (els.stepHeader) {
      if (isUpsell) {
        els.stepHeader.hidden = false;
        els.stepHeader.removeAttribute('hidden');
        if (els.stepHeading) {
          els.stepHeading.textContent = postAddMeta.upsell_heading || 'Complete your set';
        }
      } else {
        els.stepHeader.hidden = true;
        els.stepHeader.setAttribute('hidden', '');
      }
    }

    if (els.skip) {
      if (isUpsell) {
        els.skip.hidden = false;
        els.skip.removeAttribute('hidden');
        els.skip.textContent = postAddMeta.skip_label || 'Skip for now';
      } else {
        els.skip.hidden = true;
        els.skip.setAttribute('hidden', '');
      }
    }

    if (els.benefitsWrap && !isUpsell) {
      els.benefitsWrap.hidden = true;
      els.benefitsWrap.setAttribute('hidden', '');
      if (els.benefitsList) els.benefitsList.innerHTML = '';
    }

    if (els.viewProduct) {
      updateViewProductLink(isUpsell);
    }

    var root = getDrawer();
    if (root) {
      root.classList.toggle('is-upsell-step', !!isUpsell);
    }
  }

  function showUpsellStep(index) {
    productData = upsellQueue[index];
    if (!productData) return;

    upsellQueueIndex = index;
    currentVariantId = getFirstAvailableVariantId(productData);

    if (els.title) els.title.textContent = productData.title || '';
    if (els.error) {
      els.error.hidden = true;
      els.error.textContent = '';
    }

    renderBenefits();
    renderVariantButtons();
    renderVariant(currentVariantId);
  }

  function advanceUpsellStep() {
    if (isStepAnimating) return;

    if (upsellQueueIndex >= upsellQueue.length - 1) {
      close();
      return;
    }

    isStepAnimating = true;
    if (els.content) els.content.classList.add('is-step-exit');

    window.setTimeout(function () {
      showUpsellStep(upsellQueueIndex + 1);

      if (els.content) {
        els.content.classList.remove('is-step-exit');
        els.content.classList.add('is-step-enter');
      }

      requestAnimationFrame(function () {
        if (els.content) els.content.classList.remove('is-step-enter');
        isStepAnimating = false;
      });
    }, 220);
  }

  function startPostAddUpsellFlow(meta) {
    postAddMeta = meta;
    upsellQueue = meta.upsells.slice();
    upsellQueueIndex = 0;
    drawerStep = 'upsell';

    setDrawerStepUI(true);

    isStepAnimating = true;
    if (els.content) els.content.classList.add('is-step-exit');

    window.setTimeout(function () {
      showUpsellStep(0);

      if (els.content) {
        els.content.classList.remove('is-step-exit');
        els.content.classList.add('is-step-enter');
      }

      requestAnimationFrame(function () {
        if (els.content) els.content.classList.remove('is-step-enter');
        isStepAnimating = false;
      });
    }, 220);
  }

  function resetDrawerStepState() {
    drawerStep = 'main';
    upsellQueue = [];
    upsellQueueIndex = 0;
    postAddMeta = {};
    isStepAnimating = false;
    setDrawerStepUI(false);
    if (els.content) {
      els.content.classList.remove('is-step-exit', 'is-step-enter');
    }
  }

  function updateSubmitLabel() {
    if (!els.submit || editContext) return;

    var variant = getVariantById(currentVariantId);
    if (!variant) return;

    var baseLabel = variant.available ? (productData.cart_label || 'Add To Cart') : (productData.sold_out_label || 'Sold out');
    els.submit.textContent = baseLabel;
  }

  function open(data, variantId, options) {
    var root = getDrawer();
    if (!root || !data) return;

    var opts = options || {};
    openOptions = {
      hideViewProduct: !!opts.hideViewProduct,
      hideVariants: !!opts.hideVariants,
      hideUpsells: !!opts.hideUpsells || !!opts.postAddUpsell,
      postAddUpsell: !!opts.postAddUpsell
    };
    editContext =
      opts.lineKey
        ? {
            lineKey: opts.lineKey,
            quantity: opts.quantity || 1
          }
        : null;

    productData = data;
    currentVariantId = variantId || (data.variants[0] && data.variants[0].id);
    quantity = 1;
    resetDrawerStepState();

    if (els.title) els.title.textContent = data.title || '';
    if (els.error) {
      els.error.hidden = true;
      els.error.textContent = '';
    }

    renderVariantButtons();

    var initialVariant = getVariantById(currentVariantId);
    if (!initialVariant || !initialVariant.available) {
      for (var i = 0; i < data.variants.length; i++) {
        if (data.variants[i].available) {
          currentVariantId = data.variants[i].id;
          break;
        }
      }
    }

    renderVariantButtons();
    renderVariant(currentVariantId);

    root.classList.toggle('is-browse-context', isBrowseQuickAddContext());
    updateViewProductLink(false);

    root.hidden = false;
    root.removeAttribute('hidden');
    root.setAttribute('aria-hidden', 'false');

    requestAnimationFrame(function () {
      root.classList.add('is-open');
    });

    isOpen = true;
    document.body.style.overflow = 'hidden';

    if (els.submit) {
      els.submit.focus();
    }
  }

  function close() {
    var root = getDrawer();
    if (!root || !isOpen) return;

    closeInline3d();

    if (typeof window.rabitatResetSafariZoom === 'function') {
      window.rabitatResetSafariZoom();
    }

    root.classList.remove('is-open');
    root.classList.remove('is-browse-context');
    isOpen = false;
    document.body.style.overflow = '';

    setTimeout(function () {
      root.hidden = true;
      root.setAttribute('aria-hidden', 'true');
      productData = null;
      currentVariantId = null;
      editContext = null;
      openOptions = {};
      resetDrawerStepState();
      if (typeof window.rabitatResetSafariZoom === 'function') {
        window.rabitatResetSafariZoom();
      }
      if (typeof window.rabitatLockIOSViewport === 'function') {
        window.rabitatLockIOSViewport();
      }
    }, 300);

    window.setTimeout(function () {
      if (typeof window.rabitatResetSafariZoom === 'function') {
        window.rabitatResetSafariZoom();
      }
    }, 450);
  }

  function getPersonalizationTexts() {
    var texts = [];
    if (!els.slots) return texts;

    els.slots.querySelectorAll('.rabitat-quick-add__input').forEach(function (input) {
      texts.push(input.value.trim());
    });

    return texts;
  }

  function validatePersonalization(texts, pData) {
    if (!pData) return { valid: true, texts: texts };

    var slots = pData.slots && pData.slots.length ? pData.slots : [{ maxCharacters: CONFIG.maxLength }];
    var hasAnyText = texts.some(function (t) { return t.length > 0; });

    if (!hasAnyText) {
      return { valid: true, texts: texts, withPersonalization: false };
    }

    for (var i = 0; i < texts.length; i++) {
      var text = texts[i];
      if (!text) continue;

      var maxChars = (slots[i] && slots[i].maxCharacters) || CONFIG.maxLength;
      if (text.length > maxChars) {
        return { valid: false, message: 'Text exceeds maximum length for slot ' + (i + 1) + '.' };
      }

      if (!CONFIG.allowedPattern.test(text)) {
        return { valid: false, message: 'Only alphabets, numbers, and select special characters are allowed.' };
      }
    }

    return { valid: true, texts: texts, withPersonalization: true };
  }

  function getCartPropertyKey(slotIndex, slotCount) {
    if (slotCount === 1) return 'Personalization';
    return 'Personalization ' + (slotIndex + 1);
  }

  function syncCartAfterMutation(result) {
    if (window.RabitatCart && typeof window.RabitatCart.syncCartAfterAdd === 'function') {
      window.RabitatCart.syncCartAfterAdd(result);
      return;
    }

    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (response) {
        return response.json();
      })
      .then(function (cart) {
        if (window.RabitatCart && typeof window.RabitatCart.notifyUpdated === 'function') {
          window.RabitatCart.notifyUpdated(cart);
        } else {
          document.dispatchEvent(new CustomEvent('cart:updated'));
          document.dispatchEvent(
            new CustomEvent('rabitat:cart:updated', {
              detail: { item_count: cart.item_count, cart: cart }
            })
          );
        }
      });
  }

  function handleAddToCart() {
    if (isStepAnimating) return;

    var variant = getVariantById(currentVariantId);
    if (!variant || !variant.available) return;

    var pData = getPersonalizationData(variant.id);
    var texts = getPersonalizationTexts();
    var validation = validatePersonalization(texts, productData.personalizable ? pData : null);

    if (!validation.valid) {
      if (els.error) {
        els.error.textContent = validation.message;
        els.error.hidden = false;
      }
      return;
    }

    var properties = {
      engraving_required: validation.withPersonalization ? 'true' : 'false',
      image_url: variant.image || ''
    };

    if (validation.withPersonalization) {
      for (var i = 0; i < texts.length; i++) {
        if (texts[i]) {
          properties[getCartPropertyKey(i, texts.length)] = texts[i];
        }
      }
      properties['Engraving Value'] = texts.filter(Boolean).join(' | ');
    }

    if (els.submit) {
      els.submit.disabled = true;
      els.submit.classList.add('is-loading');
    }

    var addPayload;

    if (editContext) {
      addPayload = {
        id: editContext.lineKey,
        quantity: editContext.quantity,
        properties: properties
      };
    } else {
      addPayload = {
        id: variant.id,
        quantity: quantity,
        properties: properties
      };
    }

    if (window.RabitatCart && typeof window.RabitatCart.withCartSections === 'function') {
      addPayload = window.RabitatCart.withCartSections(addPayload);
    }

    fetch(editContext ? '/cart/change.js' : '/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(addPayload)
    })
      .then(function (response) {
        if (!response.ok) {
          return response.json().then(function (err) {
            throw err;
          });
        }
        return response.json();
      })
      .then(function (result) {
        if (els.submit) {
          els.submit.classList.remove('is-loading');
          els.submit.disabled = !variant.available;
        }

        var pendingPostAdd = null;
        var isUpsellStep = drawerStep === 'upsell';

        if (
          !isUpsellStep &&
          openOptions.postAddUpsell &&
          productData &&
          productData.upsells &&
          productData.upsells.length &&
          !editContext
        ) {
          pendingPostAdd = {
            upsells: productData.upsells,
            upsell_heading: productData.upsell_heading,
            upsell_benefits: productData.upsell_benefits,
            skip_label: productData.skip_label
          };
        }

        if (editContext) {
          close();
          if (window.RabitatCart && typeof window.RabitatCart.handleMutationResult === 'function') {
            window.RabitatCart.handleMutationResult(result, {
              open: false,
              focus: false,
              animate: false
            });
          } else if (window.RabitatCart && typeof window.RabitatCart.notifyUpdated === 'function') {
            window.RabitatCart.notifyUpdated(result);
          }
        } else if (isUpsellStep) {
          syncCartAfterMutation(result);
          advanceUpsellStep();
        } else if (pendingPostAdd) {
          syncCartAfterMutation(result);
          startPostAddUpsellFlow(pendingPostAdd);
        } else {
          close();
          syncCartAfterMutation(result);
        }
      })
      .catch(function (error) {
        console.error('Quick add error:', error);
        if (els.error) {
          els.error.textContent = (error && error.description) || 'Error adding to cart. Please try again.';
          els.error.hidden = false;
        }
      })
      .finally(function () {
        if (els.submit) {
          els.submit.classList.remove('is-loading');
          els.submit.disabled = !variant.available;
        }
      });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', getDrawer);
  } else {
    getDrawer();
  }

  document.addEventListener('rabitat:quick-add:open', function (event) {
    if (!event.detail || !event.detail.data) return;
    open(event.detail.data, event.detail.variantId, event.detail.options);
  });

  window.RabitatQuickAdd = {
    open: open,
    close: close
  };
})();
